import './Switch.css';
import React from 'react';
import { get, getDictionaryItem } from '../../../../../utils';
import { createFacets } from './DropDown';
import addQueryString, { removeQueryString, splitter } from '../../../../Listing/index';
import { useHistory, useLocation } from 'react-router-dom';
import { qsToObject } from '../../../../../utils/querystring';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../../../utils/tealium';
const replaceUrlPluses = function () {
  let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (str) {
    let arr = str.split('');
    let plusIndexes = [];
    arr.forEach((item, index) => {
      if (item === '+') {
        plusIndexes.push(index);
      }
    });
    if (str.includes('+') && str.includes('%20')) {
      return str.replace(/\%20/g, ' ');
    } else {
      let newStr = str;
      let newStrArr = str.split('');
      plusIndexes.forEach((el, i) => {
        // 5++days -> 5+ days
        if (el + 1 === plusIndexes[i + 1]) {
          newStrArr[el + 1] = ' ';
          newStr = newStrArr.join('');
          // 1+day -> 1 day
        } else if (plusIndexes.length === 1 && newStrArr[el + 1] !== ' ') {
          newStrArr[el] = ' ';
          newStr = newStrArr.join('');
          // 5+ day
        } else if (plusIndexes.length === 1 && newStrArr[el + 1] === ' ') {
          return str;
        }
        //business+events;,leisure+events;art+&+events
        else {
          newStrArr[el] = ' ';
          newStr = newStrArr.join('');
        }
      });
      return newStr;
    }
  }
  return str;
};
// let currentFacets:any;
const Switch = _ref => {
  let {
    fields,
    facets,
    setFilter,
    facetsName,
    selectAllLabel,
    day,
    days,
    firstQuery,
    defaultFacets,
    clearAlllFilters,
    isTagPage,
    dictionary,
    firstFilter,
    analytics,
    getFilterValue,
    rtl,
    resetAllFiltersCallback,
    autoWidth,
    summerDeals24 = false,
    isNestedFilters = true,
    params
  } = _ref;
  const location = useLocation();
  const queryParams = qsToObject(location.search);
  const label = get(fields, 'title.jss.value');
  const tagsToDisplay = get(fields, 'tagsToDisplay.values');
  const selectedTagsToDisplay = get(fields, 'preselectedTags.values');
  const filterName = get(fields, 'name');
  const [filteredOptions, setfilteredOptions] = React.useState([]);
  const filterType = get(fields, 'fieldNameItem.item.fieldName.value');
  const showSelectAllOption = get(fields, 'showSelectAllOption.jss.value');
  const [state, setstate] = React.useState('');
  const [firstLoad, setfirstLoad] = React.useState(false);
  const type = get(fields, 'fieldTypeItem.item.fieldType.value') === 'Toggle Single Select' ? 'radio' : 'checkbox';
  let history = useHistory();
  const checkboxes = React.useRef();
  React.useEffect(() => {
    if (clearAlllFilters) {
      if (selectedTagsToDisplay && selectedTagsToDisplay.length !== 0) {
        const preselectedTags = selectedTagsToDisplay.map(tag => get(tag, 'title.value') || get(tag, 'name'));
        addQueryString(facetsName, replaceUrlPluses(preselectedTags.join(',')), history);
        getFilterValue && getFilterValue(fields.name, facetsName, replaceUrlPluses(preselectedTags.join(',')));
        setFilter();
        resetAllFiltersCallback();
      } else {
        setstate('');
        const checkboxesArray = checkboxes.current.querySelectorAll('.fp__checkbox');
        for (let i = 0; i <= checkboxesArray.length - 1; i++) {
          checkboxesArray[i].checked = false;
        }
        removeQueryString(facetsName, history);
        getFilterValue && getFilterValue(fields.name, facetsName, null);
      }
    }
  }, [clearAlllFilters]);
  React.useEffect(() => {
    if (selectedTagsToDisplay && selectedTagsToDisplay.length !== 0) {
      const preselectedTags = selectedTagsToDisplay.map(tag => get(tag, 'title.value') || get(tag, 'name'));
      addQueryString(facetsName, replaceUrlPluses(preselectedTags.join(',')), history);
      setFilter(true);
    }
  }, []);
  React.useEffect(() => {
    return () => {
      removeQueryString(facetsName, history);
    };
  }, []);
  const setChecked = (key, filterType, index) => {
    let queries = queryParams[`${filterType}`];
    queries = queries && replaceUrlPluses(queries);
    let isChecked = false;
    if (index === 0 && isTagPage && !queries) {
      addQueryString(facetsName, replaceUrlPluses(key), history);
      setFilter();
      isChecked = true;

      // return isChecked;
    }
    queries && queries.split(';,;').map(item => {
      if (replaceUrlPluses(item) === key) {
        isChecked = true;
      }
    });
    return isChecked;
  };
  React.useEffect(() => {
    if (firstFilter) {
      setfilteredOptions(createFacets(tagsToDisplay, defaultFacets));
    }
    if (filterType === firstQuery) {
      setfilteredOptions(createFacets(tagsToDisplay, defaultFacets));
    } else {
      setfilteredOptions(createFacets(tagsToDisplay, facets));
    }

    //  sortFilters(filteredOptions)
  }, [facets, defaultFacets]);

  // React.useEffect(() => {
  //   if (!firstFilter) {
  //     sortFilters(filteredOptions);
  //   }
  // }, [filteredOptions]);

  const translatedKey = key => {
    if (isTagPage) {
      return getDictionaryItem(dictionary, `Type.${key}`);
    } else {
      return key;
    }
  };
  const submitFilters = e => {
    const checkboxesArray = checkboxes.current.querySelectorAll('.fp__checkbox');
    let selectedCheckboxes = [];
    for (let i = 0; i <= checkboxesArray.length - 1; i++) {
      if (checkboxesArray[i].checked) {
        selectedCheckboxes.push(checkboxesArray[i].value);
      }
    }
    selectedCheckboxes = selectedCheckboxes.join(splitter);
    addQueryString(facetsName, replaceUrlPluses(selectedCheckboxes), history);
    setFilter();
    getFilterValue && getFilterValue(fields.name, facetsName, replaceUrlPluses(selectedCheckboxes));
  };
  const sortFilters = arr => {
    if (arr.lenth !== 0) {
      // sort string values
      let sortedValues = arr.map(item => item.key).sort();
      arr.map(item => {
        sortedValues.forEach((el, index) => {
          if (item.key === el) {
            item.sortedValue = index;
          }
        });
      });
      //sort array of filters objects by sortedValues

      arr.sort((a, b) => {
        return a.sortedValue - b.sortedValue;
      });
      setfilteredOptions(arr);
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    autoWidth: autoWidth
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-toggle-multi-select switch"
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-medium filter-toggle-title"
  }, label), /*#__PURE__*/React.createElement("div", {
    ref: checkboxes,
    className: `g-checkbox g-checkbox--mob-scroll ${type === 'radio' ? 'g-checkbox-notick' : ''}`
  }, filteredOptions && filteredOptions.map((item, index) => {
    const {
      key,
      name
    } = item;
    return /*#__PURE__*/React.createElement("div", {
      key: key + index,
      className: "g-checkbox__item"
    }, /*#__PURE__*/React.createElement("input", {
      tabIndex: 0,
      value: key,
      defaultChecked: setChecked(key, filterType, index),
      checked: setChecked(key, filterType, index),
      type: type,
      className: `fp__checkbox`,
      id: `gct1-${key + index}`,
      name: "gct1",
      title: translatedKey(key),
      onChange: e => {
        tealiumClickFunc(tealiumMergeClickData(analytics['filterSelectedAnalytics'], params), [filterName, name ? name : key]);
        submitFilters(e);
      },
      onKeyPress: event => {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          event.preventDefault();
          event.target.checked = !event.target.checked;
          tealiumClickFunc(tealiumMergeClickData(analytics['filterSelectedAnalytics'], params), [filterName, name ? name : key]);
          submitFilters(event);
        }
      }
    }), /*#__PURE__*/React.createElement("label", {
      className: "body-small g-checkbox__label",
      htmlFor: `gct1-${key + index}`
    }, translatedKey(key)));
  }), showSelectAllOption && /*#__PURE__*/React.createElement("div", {
    className: "g-checkbox__item"
  }, /*#__PURE__*/React.createElement("input", {
    value: selectAllLabel,
    defaultChecked: false,
    type: type,
    className: `select-all-fp__checkbox`,
    id: `gct1-select-all`,
    name: "selectAll",
    onChange: _ref2 => {
      let {
        currentTarget
      } = _ref2;
      const checkboxesArray = checkboxes.current.querySelectorAll('.fp__checkbox');
      let selectedCheckboxes = [];
      for (let i = 0; i <= checkboxesArray.length - 1; i++) {
        checkboxesArray[i].checked = true;
        selectedCheckboxes.push(checkboxesArray[i].value);
      }
      currentTarget.checked = false;
      selectedCheckboxes = selectedCheckboxes.toString();
      addQueryString(facetsName, replaceUrlPluses(selectedCheckboxes), history);
      setFilter();
    }
  }), /*#__PURE__*/React.createElement("label", {
    className: "body-small g-checkbox__label",
    htmlFor: `gct1-select-all`
  }, selectAllLabel)))));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    autoWidth = false
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyle : ltrStyle} ${autoWidth ? 'col' : 'col-md-12'}`
  }, children);
};
export default Switch;
export const commonStyles = "c10wrcot";
const ltrStyle = "lqkobs6";
const rtlStyle = "rqtnwsa";